import { createRouter, createWebHistory } from "vue-router";
import store from "@/store/index";

const BOARD_ADMIN_TYPE = "BOARD_ADMIN";
const NORMAL_TYPE = "NORMAL";

const routes = [
  // 로그인
  {
    path: "/",
    name: "Main",
    component: () => import("@/views/Main.vue"),
  },
  {
    path: "/index.do",
    name: "Index",
    component: () => import("@/views/Main.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/auth/LoginView.vue"),
  },
  {
    path: "/index_nicednb.do",
    name: "LoginDnb",
    component: () => import("@/views/auth/LoginDnbView.vue"),
  },
  {
    path: "/issued-history",
    name: "IssuedHistory",
    component: () => import("@/views/history/IssuedHistoryView.vue"),
    meta: { authRequired: true, types: [NORMAL_TYPE] },
  },
  {
    path: "/request-history",
    name: "RequestHistory",
    component: () => import("@/views/history/RequestHistoryView.vue"),
    props: (route) => ({ type: 'request', cmpNm: route.query.cmpNm }),
    meta: { authRequired: true, types: [NORMAL_TYPE] },
  },
  {
    path: "/result-history",
    name: "ResultHistory",
    component: () => import("@/views/history/ResultHistoryView.vue"),
    props: () => ({ type: 'result' }),
    meta: { authRequired: true, types: [NORMAL_TYPE] },
  },
  {
    path: "/renewal-history",
    name: "RenewalHistory",
    component: () => import("@/views/history/RenewalHistoryView.vue"),
    props: () => ({ type: 'renewal' }),
    meta: { authRequired: true, types: [NORMAL_TYPE] },
  },
  {
    path: "/assessment/req-new",
    name: "AssessmentReqNew",
    component: () => import("@/views/assessment/AssessmentReqNewView.vue"),
    props: (route) => ({ mode: 'new', type: 'req', rBzInsNo: route.query.rBzInsNo }),
    meta: { authRequired: true, types: [NORMAL_TYPE] },
  },
  {
    path: "/assessment/req-mod",
    name: "AssessmentReqMod",
    component: () => import("@/views/assessment/AssessmentReqModView.vue"),
    props: (route) => ({ mode: 'mod', type: 'req', sNo: route.query.sNo }),
    meta: { authRequired: true, types: [NORMAL_TYPE] },
  },
  {
    path: "/assessment/rnw-new",
    name: "AssessmentRnwNew",
    component: () => import("@/views/assessment/AssessmentRnwNewView.vue"),
    props: (route) => ({ mode: 'new', type: 'rnw', sNo: route.query.sNo }),
    meta: { authRequired: true, types: [NORMAL_TYPE] },
  },
  {
    path: "/assessment/rnw-mod",
    name: "AssessmentRnwMod",
    component: () => import("@/views/assessment/AssessmentRnwModView.vue"),
    props: (route) => ({ mode: 'mod', type: 'rnw', sNo: route.query.sNo }),
    meta: { authRequired: true, types: [NORMAL_TYPE] },
  },
  {
    path: "/assessment/rtr-new",
    name: "AssessmentRtrNew",
    component: () => import("@/views/assessment/AssessmentRtrNewView.vue"),
    props: (route) => ({ mode: 'new', type: 'rtr', sNo: route.query.sNo }),
    meta: { authRequired: true, types: [NORMAL_TYPE] },
  },
  {
    path: "/assessment/rtr-mod",
    name: "AssessmentRtrMod",
    component: () => import("@/views/assessment/AssessmentRtrModView.vue"),
    props: (route) => ({ mode: 'mod', type: 'rtr', sNo: route.query.sNo }),
    meta: { authRequired: true, types: [NORMAL_TYPE] },
  },
  {
    path: "/assessment/detail",
    name: "AssessmentDetail",
    component: () => import("@/views/assessment/AssessmentDetailView.vue"),
    props: (route) => ({ sNo: route.query.sNo }),
    meta: { authRequired: true, types: [NORMAL_TYPE] },
  },
  {
    path: "/guide/service",
    name: "GuideService",
    component: () => import("@/views/guide/GuideServiceView.vue"),
    props: () => ({ type: 'service' })
  },
  {
    path: "/guide/document",
    name: "GuideDocument",
    component: () => import("@/views/guide/GuideDocumentView.vue"),
    props: () => ({ type: 'document' })
  },
  {
    path: "/guide/dnb",
    name: "GuideDnb",
    component: () => import("@/views/guide/GuideDnbView.vue"),
    props: () => ({ type: 'dnb' })
  },
  {
    path: "/cs/faq",
    name: "CsFaq",
    component: () => import("@/views/cs/CsFaqView.vue"),
    props: () => ({ type: 'faq' })
  },
  {
    path: "/cs/contactus",
    name: "CsContactus",
    component: () => import("@/views/cs/CsContactusView.vue"),
    props: () => ({ type: 'contactus' })
  },
  {
    path: "/board/note",
    name: "BoardNote",
    component: () => import("@/views/board/BoardNoteView.vue"),
    props: () => ({ type: 'note' })
  },
  {
    path: "/board/pds",
    name: "BoardPds",
    component: () => import("@/views/board/BoardPdsView.vue"),
    props: () => ({ type: 'pds' })
  },
  {
    path: "/board/note-new",
    name: "BoardNoteNew",
    component: () => import("@/views/board/BoardNoteNewView.vue"),
    props: () => ({ type: 'note', mode: 'new' }),
    meta: { authRequired: true, types: [BOARD_ADMIN_TYPE] },
  },
  {
    path: "/board/note-mod",
    name: "BoardNoteMod",
    component: () => import("@/views/board/BoardNoteModView.vue"),
    props: (route) => ({ type: 'note', mode: 'mod', postId: route.query.postId }),
    meta: { authRequired: true, types: [BOARD_ADMIN_TYPE] },
  },
  {
    path: "/board/pds-new",
    name: "BoardPdsNew",
    component: () => import("@/views/board/BoardPdsNewView.vue"),
    props: () => ({ type: 'pds', mode: 'new' }),
    meta: { authRequired: true, types: [BOARD_ADMIN_TYPE] },
  },
  {
    path: "/board/pds-mod",
    name: "BoardPdsMod",
    component: () => import("@/views/board/BoardPdsModView.vue"),
    props: (route) => ({ type: 'pds', mode: 'mod', postId: route.query.postId }),
    meta: { authRequired: true, types: [BOARD_ADMIN_TYPE] },
  },
  {
    path: "/assessment/file-upload",
    name: "AssessmentFileUpload",
    component: () => import("@/views/assessment/AssessmentFileUploadView.vue"),
    props: (route) => ({ sNo: route.query.sNo, rBzInsNo: route.query.rBzInsNo }),
    meta: { authRequired: true, types: [NORMAL_TYPE] },
  },
  {
    path: "/assessment/agree",
    name: "AssessmentAgree",
    component: () => import("@/views/assessment/AssessmentAgreeView.vue"),
    props: (route) => ({ sNo: route.query.sNo, rBzInsNo: route.query.rBzInsNo, rCmpNm: route.query.rCmpNm }),
    meta: { authRequired: true, types: [NORMAL_TYPE] },
  },
];

const router = createRouter({
  mode: "history",
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(routeInfo => routeInfo.meta.authRequired)) {
    const isLogin = store.getters["userStore/isLogin"];
    const userType = store.getters["userStore/getType"];
    
    if (!isLogin) {
      alert("로그인 후 사용하실 수 있습니다.");
      // 로그인 페이지로 이동 전에 원래 요청 URL 저장
      store.commit('userStore/SET_REDIRECT_URL', to.fullPath);
      next("/");
    } else {
      if (to.meta.types && to.meta.types.includes(userType)) {
         store.commit('userStore/CLEAR_REDIRECT_URL');
         next();
      } else {
        alert("접근할 수 없습니다.");
        next("/");
      }
    }
  } else {
    next();
  }
});

export default router;
